import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './App.css';
import TaqaInfo from './Components/TaqaInfo';
import { faArrowRight, faArrowsSpin, faArrowUp, faBolt, faBoltLightning, faCalculator, faClock, faDollarSign, faSolarPanel } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

function App() {

  const [invertorSize, setInvertorSize] = useState();
  const [cellsNumber, setCellsNumber] = useState();
  const [roofHeight, setRoofHeight] = useState();
  const [roofWidth, setRoofWidth] = useState();
  const [nightUsage, setNightUsage] = useState();
  const [morningUsage, setMorningUsage] = useState();
  const [nightHours, setNightHours] = useState();
  const [cellPrice, setCellPrice] = useState();  

  return (
    <div className="App flex flex-wrap h-screen bg-slate-900">
      <TaqaInfo />
      <div className="lg:basis-4/6 content-center bg-slate-700 w-full">
        <p className='text-slate-100 lg:text-lg md:text-base sm:text-sm xs:text-xs my-5'>للحصول على عرض انشاء نظام لتوليد الطاقة الشمسية يرجى ادخال المعلومات ادناه</p>
        <div className='mx-auto my-5'>
          <div className="flex flex-wrap gap-5">
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <select defaultValue="حجم العاكس" value={invertorSize} className="hover:scale-105 hover:bg-slate-200 duration-300 appearance-none transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md" onChange={(e) => setInvertorSize(e.target.value)}>
                <option disabled={true}>حجم العاكس</option>
                <option>3-6 KV</option>
                <option>8 KV</option>
                <option>12 KV</option>
                <option>20 KV</option>
                <option>50 KV</option>
              </select>
              <FontAwesomeIcon icon={faArrowsSpin} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <input value={cellsNumber} className="hover:scale-105 hover:bg-slate-200 duration-300 transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md placeholder-black outline-none appearance-none" type="number" placeholder="عدد الخلايا" onChange={(e) => setCellsNumber(e.target.value)} />
              <FontAwesomeIcon icon={faSolarPanel} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
          </div>
          <div className="flex flex-wrap gap-5">
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <input value={roofHeight} className="hover:scale-105 hover:bg-slate-200 duration-300 transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md placeholder-black" type="number" placeholder="طول مساحة السطح الفارغة" onChange={(e) => setRoofHeight(e.target.value)} />
              <FontAwesomeIcon icon={faArrowUp} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <input value={roofWidth} className="hover:scale-105 hover:bg-slate-200 duration-300 transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md placeholder-black" type="number" placeholder="عرض مساحة السطح الفارغة" onChange={(e) => setRoofWidth(e.target.value)} />
              <FontAwesomeIcon icon={faArrowRight} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
          </div>
          <div className="flex flex-wrap gap-5">
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <input value={cellPrice} className="hover:scale-105 hover:bg-slate-200 duration-300 transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md placeholder-black" type="number" placeholder="سعر الخلية" onChange={(e) => setCellPrice(e.target.value)} />
              <FontAwesomeIcon icon={faDollarSign} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <input value={nightHours} className="hover:scale-105 hover:bg-slate-200 duration-300 transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md placeholder-black" type="number" placeholder="عدد ساعات الليل" onChange={(e) => setNightHours(e.target.value)} />
              <FontAwesomeIcon icon={faClock} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
          </div>
          <div className="flex flex-wrap gap-5">
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <input value={nightUsage} className="hover:scale-105 hover:bg-slate-200 duration-300 transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md placeholder-black" type="number" placeholder="حمل الليل" onChange={(e) => setNightUsage(e.target.value)} />
              <FontAwesomeIcon icon={faBolt} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
            <div className="flex relative shadow-md w-96 my-5 mx-auto">
              <input value={morningUsage} className="hover:scale-105 hover:bg-slate-200 duration-300 transition p-3 focus:outline-none w-full text-slate-900 text-xs rounded-md placeholder-black" type="number" placeholder="حمل النهار" onChange={(e) => setMorningUsage(e.target.value)} />
              <FontAwesomeIcon icon={faBoltLightning} className="absolute right-2 top-3 mx-2" size='md' />
            </div>
          </div>
          <div className="flex flex-wrap gap-5">
            <button class="lg:w-1/4 justify-center mx-auto my-5 bg-gradient-to-r from-slate-600 to-slate-500 hover:bg-gradient-to-r hover:from-slate-500 hover:to-slate-400 hover:scale-105 duration-300 shadow-md text-slate-100 hover:bg-gray-400 py-2 px-4 rounded inline-flex items-center placeholder-black">
              <FontAwesomeIcon icon={faCalculator} className="mx-5" size='md' />
              <span>احسب العرض</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
